import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { Form, Input, List } from 'antd-mobile-v5'
import { WhiteSpace } from 'antd-mobile'
import { FormattedMessage, useIntl } from 'react-intl'
import DetailStatus from '../../components/common/DetailStatus'
import { formatDate, languagesMapping, removeExpires } from '../../components/common/utils'
import { mfdiTApproved } from '../../services/api'
import { usePayMfdi } from '../../services/hooks'
import DiverInfo from '../../components/FormTools/DiverInfo'
import Header from '../../components/FormTools/FormHeader'
import UploadOssFile from '../../components/FormTools/UploadOssFile'
import Signature from '../../components/FormTools/Signature'
import SearchInstructor from '../../components/FormTools/SearchInstructor'
import SearchStoreInfo from '../../components/FormTools/SearchStoreInfo'
import DatePickerTool from '../../components/FormTools/DatePicker'
import PickerTool from '../../components/FormTools/Picker'
import AddressForm from '../../components/FormTools/AddressForm'
import dayjs from 'dayjs'

import { getCookie } from '../../components/common/cookie'

const Item = List.Item

const FdiTDetail = () => {
  const [form] = Form.useForm()
  const { formatMessage } = useIntl()
  const [signature, setSignature] = useState('')
  const [instructorVerify, setInstructorVerify] = useState(false)
  const [storeVerify, setStoreVerify] = useState(false)
  const { runAsync: toPay } = usePayMfdi()
  const { detail, ossSignature } = useSelector((state) => ({
    detail: state.MFDI.MFDITDetail,
    ossSignature: state.oss.ossSignature,
  }))

  useEffect(() => {
    form.setFieldsValue({
      afdi: detail.afdi,
      afdifiles: detail.afdifiles || [],
      efri: detail.efri,
      owsi: detail.owsi,
      mfd: detail.mfd,
      teachingCount: detail.teachingCount,
      efrifiles: detail.efrifiles || [],
      fdipreFiles: detail.fdipreFiles || [],
      mfdfiles: detail.mfdfiles || [],
      teachingCountFiles: detail.teachingCountFiles || [],
      courseDate: new Date(detail.courseDate) || '',
      instructorNumber: detail.instructorInfoDTO ? detail.instructorInfoDTO.instructorNumber : '',
      storeNumber: detail.storeInfoDTO ? detail.storeInfoDTO.storeNumber : '',
      languageId: detail.languageId || '',
      regionId: detail.regionDTO ? detail.regionDTO.region : '',
      courseLocation: detail.courseLocation || '',
      addressRegionId: detail.addressRegionDTO ? detail.addressRegionDTO.id : '',
      addressStateId: detail.addressStateId || '',
      address: detail.address || '',
    })
    setSignature(detail.handwrittenSignatureUrlTrainer)
  }, [detail])

  const getSubmitData = () => {
    const values = form.getFieldsValue(true)
    const {
      storeNumber,
      regionId,
      courseDate,
      afdifiles,
      efrifiles,
      fdipreFiles,
      mfdfiles,
      teachingCountFiles,
      ...data
    } = values
    let newData = {
      ...data,
      courseDate: formatDate(courseDate, 'YYYY-MM-DD'),
      afdifiles: removeExpires(afdifiles),
      efrifiles: removeExpires(efrifiles),
      fdipreFiles: removeExpires(fdipreFiles),
      mfdfiles: removeExpires(mfdfiles),
      teachingCountFiles: removeExpires(teachingCountFiles),
    }
    if (storeVerify) newData.storeNumber = storeNumber
    return newData
  }

  const lang = getCookie('language')
  const editable = !!(detail.status === 'WAIT_CONFIRM' || detail.status === 'ADMIN_NOT_APPROVED')
  const filename = (type) => `${ossSignature.dir}${type}/${new Date().getTime()}`

  if (!Object.keys(detail).length > 0) return null
  return (
    <>
      <Header text={<FormattedMessage id="mfdi-app" />} code={detail?.code} />
      <DiverInfo info={detail.userInfoDTO} />
      <Form form={form} validateTrigger="onSubmit">
        <Form.Header>先决条件</Form.Header>
        {detail.efri ? (
          <Item>{`EFRI ${formatMessage({ id: 'afdi-satisfy' })}`}</Item>
        ) : (
          <Form.Item
            name="efrifiles"
            label={'EFRI'}
            form={form}
            rules={[
              {
                required: true,
                message: formatMessage({ id: 'form-upload-error' }),
              },
            ]}
          >
            <UploadOssFile
              form={form}
              fileName={filename('efri')}
              ossSignature={ossSignature}
              onSuccess={(file) => form.setFieldsValue({ efrifiles: file })}
              editable={editable}
              fileList={form.getFieldValue('efrifiles')}
              tips={<FormattedMessage id="common-upload-file-reminder" />}
            />
          </Form.Item>
        )}
        {detail.mfd ? (
          <Item>
            {formatMessage({ id: 'afdi-master-fd' })}
            {formatMessage({ id: 'afdi-satisfy' })}
          </Item>
        ) : (
          <Form.Item
            name="mfdfiles"
            label={formatMessage({ id: 'afdi-master-fd' })}
            form={form}
            rules={[
              {
                required: true,
                message: formatMessage({ id: 'form-upload-error' }),
              },
            ]}
          >
            <UploadOssFile
              form={form}
              fileName={filename('mfd')}
              ossSignature={ossSignature}
              onSuccess={(file) => form.setFieldsValue({ mfdfiles: file })}
              editable={editable}
              fileList={form.getFieldValue('mfdfiles')}
              tips={<FormattedMessage id="common-upload-file-reminder" />}
            />
          </Form.Item>
        )}
        {detail.afdi ? (
          <Item>
            <FormattedMessage id="mfd-padi-afd" /> <FormattedMessage id="afdi-satisfy" />
          </Item>
        ) : detail.owsi ? (
          <>
            <Item>
              <FormattedMessage id="fdi-owsi-cert" /> <FormattedMessage id="afdi-satisfy" />
            </Item>
            <Form.Item
              name="afdifiles"
              label={formatMessage({ id: 'mfd-afdi' })}
              form={form}
              rules={[
                {
                  required: true,
                  message: formatMessage({ id: 'form-upload-error' }),
                },
              ]}
            >
              <UploadOssFile
                form={form}
                fileName={filename('afdi')}
                ossSignature={ossSignature}
                onSuccess={(file) => form.setFieldsValue({ afdifiles: file })}
                editable={editable}
                fileList={form.getFieldValue('afdifiles')}
                tips={<FormattedMessage id="common-upload-file-reminder" />}
              />
            </Form.Item>
          </>
        ) : (
          <>
            <Form.Item
              name="afdifiles"
              label={formatMessage({ id: 'mfd-afdi' })}
              form={form}
              rules={[
                {
                  required: true,
                  message: formatMessage({ id: 'form-upload-error' }),
                },
              ]}
            >
              <UploadOssFile
                form={form}
                fileName={filename('afdi')}
                ossSignature={ossSignature}
                onSuccess={(file) => form.setFieldsValue({ afdifiles: file })}
                editable={editable}
                fileList={form.getFieldValue('afdifiles')}
                tips={<FormattedMessage id="mfd-afdi-upload-reminder" />}
              />
            </Form.Item>
            <Form.Item
              name="fdipreFiles"
              label={formatMessage({ id: 'mermaid-other-files' })}
              form={form}
              rules={[
                {
                  required: true,
                  message: formatMessage({ id: 'form-upload-error' }),
                },
              ]}
            >
              <UploadOssFile
                form={form}
                fileName={filename('prepare')}
                ossSignature={ossSignature}
                onSuccess={(file) => form.setFieldsValue({ fdipreFiles: file })}
                editable={editable}
                fileList={form.getFieldValue('fdipreFiles')}
                tips={<FormattedMessage id="app-health" />}
              />
            </Form.Item>
          </>
        )}
        <Form.Header>签证要求</Form.Header>
        {detail.teachingCount ? (
          <Item>{`${formatMessage({ id: 'mfdi-satisfy-certs' })}`}</Item>
        ) : (
          <Form.Item
            name="teachingCountFiles"
            label={formatMessage({ id: 'afdi-certs-Requirement' })}
            form={form}
            rules={[
              {
                required: true,
                message: formatMessage({ id: 'form-upload-error' }),
              },
            ]}
          >
            <UploadOssFile
              form={form}
              fileName={filename('teachingCerts')}
              ossSignature={ossSignature}
              onSuccess={(file) => form.setFieldsValue({ teachingCountFiles: file })}
              editable={editable}
              fileList={form.getFieldValue('teachingCountFiles')}
              tips={<FormattedMessage id="mfdi-upload-cert-requirement" />}
            />
          </Form.Item>
        )}
        <Form.Header>训练信息</Form.Header>
        {(editable || (!editable && detail.instructorInfoDTO)) && (
          <SearchInstructor
            idType={'trainer'}
            type={'NONE'}
            form={form}
            editable={editable}
            instructorVerify={instructorVerify}
            setInstructorVerify={setInstructorVerify}
            required={true}
            initInstructorInfo={detail.instructorInfoDTO}
          />
        )}
        {(editable || (!editable && detail.storeInfoDTO)) && (
          <SearchStoreInfo
            form={form}
            setStoreVerify={setStoreVerify}
            storeVerify={storeVerify}
            editable={editable}
            initStoreInfo={detail.storeInfoDTO}
          />
        )}
        <Form.Item
          form={form}
          name="courseLocation"
          label={formatMessage({ id: 'si-course-location-title' })}
          rules={[
            {
              required: true,
              message: formatMessage({ id: 'si-course-location' }),
            },
          ]}
        >
          <Input />
        </Form.Item>
        <DatePickerTool
          name="courseDate"
          placeholder={formatMessage({ id: 'efri-course-date-error' })}
          disabled={!editable}
          label={formatMessage({ id: 'common-course-date' })}
          rules={[
            {
              required: true,
              message: formatMessage({ id: 'efri-course-date-error' }),
            },
          ]}
          max={dayjs().toDate()}
        />
        <Form.Header>教学地址及语言</Form.Header>
        <Form.Item name="regionId" label={formatMessage({ id: 'dm-region' })} disabled={true}>
          <Input />
        </Form.Item>
        <PickerTool
          name={'languageId'}
          form={form}
          rules={[
            {
              required: true,
              message: '语言不能为空',
            },
          ]}
          placeholder={formatMessage({ id: 'dm-lang-error' })}
          data={languagesMapping}
          label={formatMessage({ id: 'dm-lang-title' })}
          disabled={!editable}
        />
        <Form.Header>地址信息</Form.Header>
        <AddressForm form={form} editable={editable} />
      </Form>
      <WhiteSpace />
      <Signature
        title={formatMessage({ id: 'dm-form-signature' })}
        filePath={'signature'}
        modified={editable}
        oss={ossSignature}
        onSuccess={(imgUrl) => setSignature(imgUrl)}
        onClear={() => setSignature('')}
        initSignature={detail.handwrittenSignatureUrlTrainer}
      />
      <WhiteSpace />
      <DetailStatus
        form={form}
        detail={detail}
        approveFn={mfdiTApproved}
        getSubmitData={getSubmitData}
        payFn={toPay}
        listUrl={'/mfdi_app_list'}
        payApplicationType={'MEMBER_APPLICATION_MFDI'}
        signature={signature}
      />
    </>
  )
}

export default FdiTDetail
